export function isAsyncBasegridResponse(data) {
  return Boolean(
    data &&
      !Array.isArray(data) &&
      data.execution === "async" &&
      data.status === "processing"
  );
}

export function isRunningBasegridError(error) {
  return Boolean(
    error?.response?.status === 409 &&
      error?.response?.data?.status === "already_processing"
  );
}
